import { serializable, alias, object, primitive } from 'serializr';
import { Metrics } from './metrics.model';
  
  export class DQRMetrics {
    @serializable(alias('dqr_metrics', object(Metrics)))
    dqrMetrics?: Metrics;
  
    @serializable(alias('total_score', primitive()))
    totalScore?: number;
  }